import React, {useState} from 'react';
import Switch from 'react-switch';
import {ServicioOfrecidoEmpresaAdmin} from './ServicioOfrecidoEmpresaAdmin';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';

export const TipoServiciosEmpresaAdmin = (props) => {
	const {
		ServiciosPosibles,
		setServiciosPosibles,
		CategoriasPosibles,
		cambiarEstadoServ,
		IsDisabled,
	} = props;
	const [servicios, setServicios] = React.useState([]);

	const [ModalAnadirServicio, setModalAnadirServicio] = useState(false);
	const [ServicioAnadido, setServicioAnadido] = useState({
		nombreServicio: '',
		precioServicio: '0',
		horasMinServicio: '0',
	});

	const anadirServiciosAdmin = () => {
		//
		// ENVIAR LOS DATOS A LA BD
		//
		// VOLVER HACER LA CONSULTA A LA BD Y VOLVER A CARGAR LOS SERVICIO
		//
		setModalAnadirServicio(false);
	};

	/**
	 * It takes an event and an index, and then it sets the value of the input to the max of 0 and the
	 * min of 1000000, and then it sets the value of the input to the value of the input
	 */
	const setServisNumber = (e, id) => {
		const min = 1;
		const max = 1000000;
		const value = Math.max(min, Math.min(max, Number(e.target.value)));
		setServiciosPosibles(
			ServiciosPosibles.map((servicio) => {
				if (servicio.id === id) {
					return {...servicio, [e.target.name]: value};
				} else {
					return servicio;
				}
			})
		);
	};

	/**
	 * It takes an index as an argument, and then it maps through the servicios array, and if the key
	 * of the current item in the array is equal to the index, it returns a new object with the same
	 * properties as the current item, but with the estado property set to the opposite of what it was
	 * before
	 */
	const setServisEstado = (index) => {
		setServicios(
			servicios.map((servicio) => {
				if (servicio.key === index) {
					return {...servicio, estado: !servicio.estado};
				} else {
					return servicio;
				}
			})
		);
	};

	const haySeleccion = () => {
		let axu = false;
		CategoriasPosibles.map((cat) => {
			if (cat.estado) {
				axu = true;
			}
		});
		return axu;
	};
	return (
		haySeleccion() > 0 && (
			<>
				<div className='separadorFormEmpresas'></div>
				<div className='TipoServiciosEmpresa'>
					<div className='headTipoServ'>
						<h2>Servicios ofrecidos</h2>
					</div>

					<div className='tablaServiciosOfrecidos'>
						{CategoriasPosibles.map(
							(categoria, index) =>
								categoria.estado && (
									<div
										className='content-tablaServiciosOfrecidos'
										key={index}
									>
										<div className='separador'></div>
										<div className='titulo-categoria'>
											{categoria.categoria_id.nombre.toUpperCase()}
										</div>
										<div className='lista-servicios-ofrecidos'>
											{ServiciosPosibles.map(
												(serv) =>
													serv.servicio_id.categoria_id.nombre ===
														categoria.categoria_id.nombre && (
														<ServicioOfrecidoEmpresaAdmin
															IsDisabled={IsDisabled}
															servicio={serv}
															cambiarEstadoServ={cambiarEstadoServ}
															setServisNumber={setServisNumber}
														/>
													)
											)}
										</div>
									</div>
								)
						)}
					</div>
				</div>
			</>
		)
	);
};
/**










 */
